/**
 * FHIR R4 Resource Types
 *
 * Comprehensive enum of resource types supported by Symphony.
 */
export enum FhirResourceType {
  AllergyIntolerance = 'AllergyIntolerance',
  Appointment = 'Appointment',
  CarePlan = 'CarePlan',
  CareTeam = 'CareTeam',
  Condition = 'Condition',
  Device = 'Device',
  DiagnosticReport = 'DiagnosticReport',
  Encounter = 'Encounter',
  Immunization = 'Immunization',
  Location = 'Location',
  Medication = 'Medication',
  MedicationRequest = 'MedicationRequest',
  Observation = 'Observation',
  Organization = 'Organization',
  Patient = 'Patient',
  Practitioner = 'Practitioner',
  Procedure = 'Procedure',
  Questionnaire = 'Questionnaire',
  QuestionnaireResponse = 'QuestionnaireResponse',
  ServiceRequest = 'ServiceRequest',
}

/** Type guard to check if a string is a valid {@link FhirResourceType}. */
export function isFhirResourceType(value: string): value is FhirResourceType {
  return Object.values(FhirResourceType).includes(value as FhirResourceType);
}

/** Display labels for resource types (user-friendly names). */
export const FHIR_RESOURCE_TYPE_LABELS: Record<FhirResourceType, string> = {
  [FhirResourceType.AllergyIntolerance]: 'Allergy Intolerance',
  [FhirResourceType.Appointment]: 'Appointment',
  [FhirResourceType.CarePlan]: 'Care Plan',
  [FhirResourceType.CareTeam]: 'Care Team',
  [FhirResourceType.Condition]: 'Condition',
  [FhirResourceType.Device]: 'Device',
  [FhirResourceType.DiagnosticReport]: 'Diagnostic Report',
  [FhirResourceType.Encounter]: 'Encounter',
  [FhirResourceType.Immunization]: 'Immunization',
  [FhirResourceType.Location]: 'Location',
  [FhirResourceType.Medication]: 'Medication',
  [FhirResourceType.MedicationRequest]: 'Medication Request',
  [FhirResourceType.Observation]: 'Observation',
  [FhirResourceType.Organization]: 'Organization',
  [FhirResourceType.Patient]: 'Patient',
  [FhirResourceType.Practitioner]: 'Practitioner',
  [FhirResourceType.Procedure]: 'Procedure',
  [FhirResourceType.Questionnaire]: 'Questionnaire',
  [FhirResourceType.QuestionnaireResponse]: 'Questionnaire Response',
  [FhirResourceType.ServiceRequest]: 'Service Request',
};
